import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import "./index.css";
import { Link } from "react-router-dom";

/* API requests */
import { getYacht } from "../../../../api-requests/yacht";
import { getYachtListings, deleteJob, archiveJob, handleDraft } from "../../../../api-requests/job";

/* Helpers */
import { handleContractType, handleStartDate, handleJobSalary, handleYachtName } from "../../../../helpers/job";

/* Actions */
import { setAlert } from "../../../../redux/actions/misc";

/* Components */
import ConfirmModal from "../../../../components/ConfirmModal";

const PlusIcon = () => (
    <svg width={16} height={16} viewBox="0 0 24 24" fill="none">
        <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    </svg>
);

class YachtListings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            yacht: null,
            drafts: [],
            archived: [],
            active: [],
            isFetching: true,
            archiveTarget: null,
            isArchiving: false,
        };
    }

    componentDidMount() {
        const dash = document.getElementById("Dashboard");
        if (dash && dash.scrollTo) dash.scrollTo(0, 0);

        if (this.props.match.params.yachtId) {
            return getYachtListings(this.props.match.params.yachtId)
                .then(listings => getYacht(this.props.match.params.yachtId)
                    .then(yacht => this.setState({ yacht, drafts: listings.drafts, archived: listings.archived, active: listings.active, isFetching: false }))
                );
        }
    }

    refresh = () => getYachtListings(this.props.match.params.yachtId)
        .then(result => this.setState({ drafts: result.drafts, archived: result.archived, active: result.active }));

    handleDelete = (_id) => deleteJob(_id).then(result => {
        if (result.success) {
            this.refresh().then(() => {
                this.props.setAlert("Listing deleted.", "success", true);
                setTimeout(() => this.props.setAlert("Listing deleted.", "success", false), 2700);
            });
        }
    });

    requestArchive = (post) => this.setState({ archiveTarget: post });

    cancelArchive = () => {
        if (this.state.isArchiving) return;
        this.setState({ archiveTarget: null });
    };

    confirmArchive = () => {
        const target = this.state.archiveTarget;
        if (!target || this.state.isArchiving) return;
        this.setState({ isArchiving: true });
        return archiveJob(target._id).then(result => {
            if (result.success) {
                return this.refresh().then(() => {
                    this.setState({ archiveTarget: null, isArchiving: false });
                    this.props.setAlert("Listing archived.", "success", true);
                    setTimeout(() => this.props.setAlert("Listing archived.", "success", false), 2700);
                });
            }
            this.setState({ isArchiving: false });
        });
    };

    handleRelistPosition = (post) => handleDraft("", post, post.yacht, post.postedBy)
        .then(result => this.props.history.push(`/yachts/listings/${result.data.yacht}/add?job=${result.data._id}&status=archived`));

    sortByApplications = (a, b) => {
        if (a.newApplications && b.newApplications) {
            if (a.newApplications.length > b.newApplications.length) return -1;
            if (a.newApplications.length < b.newApplications.length) return 1;
        }
        return 0;
    }

    renderPlaceholders = () => {
        return [1, 2, 3, 4, 5, 6, 7, 8].map((_, index) => <div className="listing-row-placeholder" key={index} />);
    }

    renderRowCore = (post) => (
        <>
            <div className="listing-row-position">
                <p className="listing-row-position-title">{post?.position?.name || "—"}</p>
                {post.reference && <p className="listing-row-position-ref">Ref {post.reference}</p>}
            </div>
            <div className="listing-row-cell">{handleStartDate(post)}</div>
            <div className="listing-row-cell">{handleJobSalary(post)}</div>
            <div className="listing-row-cell">{handleContractType(post)}</div>
        </>
    );

    renderDrafts = (posts) => {
        if (!posts.length) return <p className="admin-empty-state">No draft listings yet.</p>;
        return posts.map((post, index) => (
            <div key={index} className="listing-row admin-card">
                <Link className="listing-row-clickable" to={`/yachts/listings/${post.yacht._id}/add?job=${post._id}&status=draft`}>
                    {this.renderRowCore(post)}
                </Link>
                <div className="listing-row-actions">
                    <Link className="listing-row-primary" to={`/yachts/listings/${post.yacht._id}/add?job=${post._id}&status=draft`}>Complete listing</Link>
                    <div className="listing-row-trash" title="Delete forever">
                        <img src={require("../../../../assets/svgs/trash.svg")} alt="" />
                        <div className="listing-row-trash-confirm" onClick={() => this.handleDelete(post._id)}>
                            <img src={require("../../../../assets/svgs/trash.svg")} alt="" />
                            <p>Delete forever</p>
                        </div>
                    </div>
                </div>
            </div>
        ));
    }

    renderArchive = (posts) => {
        if (!posts.length) return <p className="admin-empty-state">No archived listings yet.</p>;
        return posts.map((post, index) => (
            <div key={index} className="listing-row admin-card">
                <div className="listing-row-clickable" onClick={() => this.handleRelistPosition(post)} role="button">
                    {this.renderRowCore(post)}
                </div>
                <div className="listing-row-actions">
                    <button type="button" className="listing-row-secondary" onClick={() => this.handleRelistPosition(post)}>Re-list position</button>
                    <div className="listing-row-trash" title="Delete forever">
                        <img src={require("../../../../assets/svgs/trash.svg")} alt="" />
                        <div className="listing-row-trash-confirm" onClick={() => this.handleDelete(post._id)}>
                            <img src={require("../../../../assets/svgs/trash.svg")} alt="" />
                            <p>Delete forever</p>
                        </div>
                    </div>
                </div>
            </div>
        ));
    }

    renderActive = (posts) => {
        if (!posts.length) return <p className="admin-empty-state">No active listings yet. Add the first one below.</p>;
        const sorted = posts.sort(this.sortByApplications);
        return sorted.map((post, index) => (
            <div key={index} className="listing-row admin-card">
                <Link className="listing-row-clickable" to={`/yachts/listings/${post.yacht._id}/applications/${post._id}`}>
                    <div className="listing-row-position">
                        <p className="listing-row-position-title">{post?.position?.name || "—"}</p>
                        <div className="listing-row-counters">
                            <span className="listing-row-counter" title="Total applications">
                                <img src={require("../../../../assets/svgs/total-applications.svg")} alt="" />
                                <span className="listing-row-counter-num">{post.applications.length}</span>
                            </span>
                            <span className={`listing-row-counter${post.newApplications.length > 0 ? " is-new" : ""}`} title="New applications">
                                <img src={post.newApplications.length < 1 ? require("../../../../assets/svgs/no-new-applications.svg") : require("../../../../assets/svgs/new-applications.svg")} alt="" />
                                <span className="listing-row-counter-num">{post.newApplications.length}</span>
                            </span>
                            {post.reference && <span className="listing-row-position-ref">Ref {post.reference}</span>}
                        </div>
                    </div>
                    <div className="listing-row-cell">{handleStartDate(post)}</div>
                    <div className="listing-row-cell">{handleJobSalary(post)}</div>
                    <div className="listing-row-cell">{handleContractType(post)}</div>
                </Link>
                <div className="listing-row-actions">
                    <Link className="listing-row-primary" to={`/yachts/listings/${post.yacht._id}/applications/${post._id}`}>Applications</Link>
                    <div className="listing-row-more" title="More">
                        <img src={require("../../../../assets/svgs/more.svg")} alt="" />
                        <div className="listing-row-more-menu">
                            <Link className="listing-row-more-item" to={`/yachts/listings/${post.yacht._id}/add?job=${post._id}&status=active`}>
                                <img src={require("../../../../assets/svgs/edit-dark.svg")} alt="" />
                                <p>Edit details</p>
                            </Link>
                            <div className="listing-row-more-item" onClick={() => this.requestArchive(post)}>
                                <img src={require("../../../../assets/svgs/end-listing.svg")} alt="" />
                                <p>End &amp; archive</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ));
    }

    render() {

        const yachtId = this.props.match.params.yachtId;
        const status = this.props.match.params.status;
        const activeTab = status === "archived" ? "archived" : status === "drafts" ? "drafts" : "active";
        const yacht = this.state.yacht;
        const yachtName = yacht ? handleYachtName(yacht) : "Yacht listings";

        return(
            <div className="admin-page">
                <header className="admin-page-header">
                    <div className="admin-page-header-titles">
                        <h1 className="admin-page-title">{yachtName}</h1>
                        <p className="admin-page-subtitle">Listings for this yacht.</p>
                    </div>
                    {activeTab === "active" &&
                        <Link to={`/yachts/listings/${yachtId}/add`} className="admin-page-action admin-page-action--primary">
                            <PlusIcon />
                            <span>New listing</span>
                        </Link>
                    }
                </header>

                <div className="admin-toolbar">
                    <nav className="admin-tabs" aria-label="Listing status">
                        <Link to={`/yachts/listings/${yachtId}/active`} className={`admin-tab${activeTab === "active" ? " is-active" : ""}`}>
                            <span className="admin-tab-label">Active</span>
                        </Link>
                        <Link to={`/yachts/listings/${yachtId}/archived`} className={`admin-tab${activeTab === "archived" ? " is-active" : ""}`}>
                            <span className="admin-tab-label">Archived</span>
                        </Link>
                        <Link to={`/yachts/listings/${yachtId}/drafts`} className={`admin-tab${activeTab === "drafts" ? " is-active" : ""}`}>
                            <span className="admin-tab-label">Drafts</span>
                            {this.state.drafts.length > 0 && <span className="admin-tab-count">{this.state.drafts.length}</span>}
                        </Link>
                    </nav>
                </div>

                <div className="listing-row-header">
                    <div className="listing-row-header-position">Position</div>
                    <div className="listing-row-header-cell">Start date</div>
                    <div className="listing-row-header-cell">Salary</div>
                    <div className="listing-row-header-cell">Contract</div>
                    <div className="listing-row-header-actions">Actions</div>
                </div>

                <div className="admin-card-list">
                    {this.state.isFetching && this.renderPlaceholders()}
                    {!this.state.isFetching && activeTab === "active" && this.renderActive(this.state.active)}
                    {!this.state.isFetching && activeTab === "archived" && this.renderArchive(this.state.archived)}
                    {!this.state.isFetching && activeTab === "drafts" && this.renderDrafts(this.state.drafts)}
                </div>

                <ConfirmModal
                    show={!!this.state.archiveTarget}
                    title={"End & archive this listing?"}
                    description={this.state.archiveTarget ? `${this.state.archiveTarget?.position?.name || "This position"} will be moved to the Archived tab. Candidates will no longer be able to apply. You can re-list it later from the Archived tab.` : ""}
                    confirmLabel={this.state.isArchiving ? "Archiving…" : "End & archive"}
                    cancelLabel={"Keep listing"}
                    destructive={true}
                    busy={this.state.isArchiving}
                    onConfirm={this.confirmArchive}
                    onCancel={this.cancelArchive}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({ admin: state.admin });
const mapDispatchToProps = (dispatch) => ({ ...bindActionCreators({ setAlert }, dispatch) });

export default connect(mapStateToProps, mapDispatchToProps)(YachtListings);
